// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2b5L1","name":"Header_name__cAu0G","birthday":"Header_birthday__lWQBX","skeleton":"Header_skeleton__2vWWS"};